import { FC, useEffect, useState } from 'react';
import { isArray } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import V2Title from '@/common/components/Feedback/V2Title';
import V2Empty from '@/common/components/Data/V2Empty';
import V2Tag from '@/common/components/Data/V2Tag';
import V2LogRecord from '@/common/components/SpecialBusiness/V2LogRecord';
import V2DetailGroup from '@/common/components/Feedback/V2DetailItem/Group';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';
import { postFranchiseeFollowRecordPage } from '@/common/api/expandStore/franchisee';
import styles from '../index.module.less';

/** 跟进记录拉取条数（不做分页器，超出后在容器内滚动） */
const PAGE_SIZE = 100;

/**
 * @Description 加盟商详情内，跟进记录
 */
const FollowRecords: FC<{
  franchiseeId: number;
  /** 刷新标识，变化时重新拉取 */
  refreshFlag: number;
}> = ({
  franchiseeId,
  refreshFlag,
}) => {

  const [records, setRecords] = useState<any[]>([]);

  const methods = useMethods({
    /** 获取跟进记录列表 */
    getRecords() {
      postFranchiseeFollowRecordPage({
        franchiseeId,
        page: 1,
        size: PAGE_SIZE,
      }).then((data: any) => {
        setRecords(isArray(data?.objectList) ? data.objectList : []);
      });
    },

    /** 将跟进记录转换为时间线组件所需的数据结构 */
    getLogRecordItems() {
      return records.map((item) => {
        // const imageAssets = isArray(item?.imageList) ? item.imageList.map((url) => ({ url, name: '' })) : [];
        const fileAssets = isArray(item?.fileList) ? item.fileList.map(({ name, url }) => ({ name, url })) : [];

        return {
          date: item?.followDate,
          status: 'finish', // 让时间线呈现蓝色
          children: [{
            name: '',
            description: <div className={styles.followRecordDescription}>
              <div className={styles.followRecordHead}>
                <span className={styles.followRecordUser}>{item?.accountName}</span>
                {item?.followTypeName ? <V2Tag style={{ backgroundColor: 'rgba(0, 29, 140, 0.08)', color: '#001D8C' }}>{item.followTypeName}</V2Tag> : <></>}
              </div>
              <div className={styles.followRecordText}>{item?.content}</div>
              {/* {!!imageAssets.length && <V2DetailGroup
                moduleType='easy'
                className='mb-12'
              >
                <V2DetailItem
                  type='images'
                  assets={imageAssets}
                  noStyle
                />
              </V2DetailGroup>} */}
              {!!fileAssets.length && <V2DetailGroup
                moduleType='easy'
                className='mb-12'
              >
                <V2DetailItem
                  type='files'
                  assets={fileAssets}
                  noStyle
                />
              </V2DetailGroup>}
            </div>,
          }],
        };
      });
    },
  });

  useEffect(() => {
    if (!franchiseeId) return;
    methods.getRecords();
  }, [franchiseeId, refreshFlag]);

  return (
    <div className={styles.followRecords}>
      <V2Title type='H2' text='跟进记录' divider className='mb-16'/>
      {
        records.length ? <div className={styles.followRecordList}>
          <V2LogRecord items={methods.getLogRecordItems()} type={2} />
        </div> : <V2Empty customTip='暂无记录'/>
      }
    </div>
  );
};

export default FollowRecords;
